module.exports = __webpack_public_path__ + "static/media/icons-20-profile.f03e3813.svg";